export enum RouteNames {
  ROOT = "/",
  LOGIN = "/login",
  LOGOUT = "/logout",
  LOGIN_ERROR = "/error",
  CHAT = "/chat",
  USER = "/user",
  APPS = "/apps/:slug?",
  KNOWLEDGE_BASE = "/knowledge-base",
  MODE_IMPORT = "/mode-import/:hash",
  MEMORY = "/memory",
  MODE_STORE = "/mode-store",
  KIOSK = "/kiosk/:modeId?",
  TEAMS_AUTH_COMPLETE = "/teams-auth-complete",
}
